'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = undefined;

var _jsx2 = require('babel-runtime/helpers/jsx');

var _jsx3 = _interopRequireDefault(_jsx2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _urls = require('../../../utils/urls');

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propsComparer = require('../../../utils/propsComparer');

var _propsComparer2 = _interopRequireDefault(_propsComparer);

var _reactIntl = require('react-intl');

var _components = require('../../../components');

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _LACrown = require('./LACrown.scss');

var _LACrown2 = _interopRequireDefault(_LACrown);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LACrown = function (_Component) {
    (0, _inherits3.default)(LACrown, _Component);

    function LACrown() {
        var _ref;

        var _temp, _this, _ret;

        (0, _classCallCheck3.default)(this, LACrown);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = LACrown.__proto__ || (0, _getPrototypeOf2.default)(LACrown)).call.apply(_ref, [this].concat(args))), _this), _this.classicLink = function (classicBaseUrl, pathName) {
            if (pathName.includes('/auctioneer/') && pathName.endsWith('past/')) {
                return '' + classicBaseUrl + pathName.replace('past/', '');
            }
            return '' + classicBaseUrl + pathName;
        }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
    }

    (0, _createClass3.default)(LACrown, [{
        key: 'shouldComponentUpdate',
        value: function shouldComponentUpdate(nextProps) {
            return (0, _propsComparer2.default)(this.props.location, nextProps.location, ['pathname']);
        }
    }, {
        key: 'render',
        value: function render() {
            var _props = this.props,
                baseUrl = _props.baseUrl,
                classicBaseUrl = _props.classicBaseUrl,
                location = _props.location;


            return (0, _jsx3.default)('div', {
                className: _LACrown2.default.crown
            }, void 0, (0, _jsx3.default)('div', {
                className: _LACrown2.default['crown-inner']
            }, void 0, (0, _jsx3.default)(_components.Link, {
                route: true,
                to: (0, _urls.getAuctioneerDirectoryUrl)(),
                secondary: true
            }, void 0, (0, _jsx3.default)(_reactIntl.FormattedMessage, {
                id: 'directory'
            })), (0, _jsx3.default)(_components.Link, {
                route: true,
                to: (0, _urls.getAuctionResultsUrl)(),
                secondary: true
            }, void 0, (0, _jsx3.default)(_reactIntl.FormattedMessage, {
                id: 'price_results'
            })), (0, _jsx3.default)(_components.Link, {
                target: '_blank',
                to: baseUrl + '/news/',
                secondary: true
            }, void 0, (0, _jsx3.default)(_reactIntl.FormattedMessage, {
                id: 'news'
            })), (0, _jsx3.default)(_components.Link, {
                target: '_blank',
                to: 'http://liveauctioneers.desk.com/',
                secondary: true,
                rel: 'noopener'
            }, void 0, (0, _jsx3.default)(_reactIntl.FormattedMessage, {
                id: 'help'
            })), (0, _jsx3.default)(_components.Link, {
                route: true,
                to: '/consignments',
                secondary: true
            }, void 0, (0, _jsx3.default)(_reactIntl.FormattedMessage, {
                id: 'consign'
            })), (0, _jsx3.default)('span', {}, void 0, '|'), (0, _jsx3.default)(_components.Link, {
                to: this.classicLink(classicBaseUrl, location.pathname),
                secondary: true,
                rel: 'nofollow'
            }, void 0, (0, _jsx3.default)(_reactIntl.FormattedMessage, {
                id: 'classic_site'
            }))));
        }
    }]);
    return LACrown;
}(_react.Component);

exports.default = LACrown;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Header/LACrown/LACrown.js
// module id = /7aV
// module chunks = 57